/**
 * Stringify the data to be passed to sentry
 * @param {any[]} args
 */
export function stringify(args: any[]): string {
  return args
    .map((item) => {
        if (item instanceof Error || typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') {
          return item.toString()
        }
        return JSON.stringify(item)
      }).join(' ')
}
